
import { Component, Vue, Emit, Watch, Prop } from "vue-property-decorator";
import rest from "@/rest";
// components
import ExpandableCard from "../Shared/ExpandableCard.vue";
// interfaces
import { namespace } from "vuex-class";
import { ExerciseVM } from "@/interfaces/ExerciseVM";
import { CourseElementVm } from "@/interfaces/CourseElementVm";
import { ParamDictionary } from "@/interfaces/ParamDictionary";
import { CourseElementType } from "@/interfaces/CourseElementType";
import { courseElementTypeItems } from "@/interfaces/Types";

const globals = namespace("globals");

@Component({
  components: {
    ExpandableCard,
  },
})
export default class TtsReaderElementSettings extends Vue {
  @globals.Getter selectedElement!: CourseElementVm | null;
  @globals.Getter selectedExercise!: ExerciseVM | null;
  courseElementTypeItems = courseElementTypeItems;

  isBusy = false;

  mounted() {}

  getElementTitle(type: string | null): string {
    const element = this.courseElementTypeItems.find(el => CourseElementType[el.value] === type);
    return element ? element.label : '';
  }

  getElementIcon(type: string | null): string {
    const element = this.courseElementTypeItems.find(el => CourseElementType[el.value] === type);
    return element ? element.icon : '';
  }
}
